import React from 'react';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import {local} from '../../../Context/Local';
import { useHistory } from 'react-router-dom';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
// import FavoriteIcon from '@material-ui/icons/Favorite';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LocalMallIcon from '@material-ui/icons/LocalMall';
import CardActionArea from '@material-ui/core/CardActionArea';

import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import ReceiptTwoToneIcon from '@material-ui/icons/ReceiptTwoTone';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
import SyncAltRoundedIcon from '@material-ui/icons/SyncAltRounded';
import ListAltIcon from '@material-ui/icons/ListAlt';

// cuG
import {useStyleC} from '../st/UseStyle';
// csG
import {style} from '../st/cStyle'

import Icons from './Icons';


export default function CardN({title}) {
  const classes = useStyleC();
  let his = useHistory();
  const [expanded, setExpanded] = React.useState(false);

  const dept = (i) => {
    // console.log(local[i])
    his.push({
      pathname: '/depts',
      state: { local:local[i], },
    })
  };
  
  return (

    <Card className={classes.root}>

      <CardActionArea onClick={()=>dept(0)} >
      <CardMedia className={classes.media} title="" >
         <LocalMallIcon className={classes.iconCard} style={style.color.sal}/>
      </CardMedia>

      <CardContent className={classes.content} style={style.color.sal}>
        <Typography variant="h5">
       {title}
        </Typography>
      </CardContent>
      </CardActionArea>
      <CardActions disableSpacing className={classes.actions}>
        {/* <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton> */}
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent className={classes.slidcontent} >
          {/* <Typography > */}
            {/*  */}
          {/* </Typography> */}

          {/* <Typography > */}
          <Icons/> 
          {/* </Typography> */}

        </CardContent>
      </Collapse>
    </Card>
  );
}

